import { render, staticRenderFns } from "./workorderpacklist.vue?vue&type=template&id=2a2d5b0b&scoped=true&"
import script from "./workorderpacklist.vue?vue&type=script&lang=js&"
export * from "./workorderpacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d5b0b",
  null
  
)

export default component.exports